import { render, staticRenderFns } from "./RegisterModel.vue?vue&type=template&id=01c15b8a&scoped=true&"
import script from "./RegisterModel.vue?vue&type=script&lang=ts&"
export * from "./RegisterModel.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterModel.vue?vue&type=style&index=0&id=01c15b8a&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c15b8a",
  null
  
)

export default component.exports